import Vue from 'vue';
import MyStore from '@rei/my-store';


const myStoreToggleButton = document.querySelector("[data-ui='site-header-action-local']");
const navbarWrapper = document.querySelector("[data-ui='site-navigation']");
let isMyStoreMounted = false;

// Mount mystore and set event listeners, this function will only be executed if my storeToggleButton is hover or focused,
// Otherwise there is no need to mount component
const mountMyStore = () => {
  isMyStoreMounted = true;

  const data = {
    open: false,
  };
  
  const eventBus = new Vue({});

  // Insert <li> element next to storeToggle button to render MyStore component
  myStoreToggleButton.parentNode.insertAdjacentHTML('afterEnd', '<li class="stores-dropdown"><div id="my-store-placement"></div></li>');
  const storesDropdown = document.querySelector(".stores-dropdown");

  new Vue({
    el: '#my-store-placement',
    data,
    render: app => app(MyStore, {
      props: {
        open: data.open,
        customClasses: ['custom-class'],
        trapTabInsideWidget: true
      },
      on: {
        closed() {
          eventBus.$emit('closed');
        },
        'on-escape'() {
          eventBus.$emit('closed');
        },
      }
    }),
    methods: {
      toggle() {
        this.open = !this.open;
      },
      handleClose() {
        this.open = false;
        myStoreToggleButton.setAttribute('aria-expanded', 'false');
        navbarWrapper.style.overflowY = 'initial';  
        myStoreToggleButton.focus();
      },
      toggleButtonHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        const { clientWidth } = window.document.body;
  
        this.toggle();
        document.body.classList.remove('sign-in-open');
        myStoreToggleButton.setAttribute('aria-expanded', this.open ? 'true' : 'false');
        navbarWrapper.style.overflowY = this.open && clientWidth < 992 ? 'hidden' : 'initial';
        storesDropdown.style.display = this.open ? 'block' : 'none';
      },
      clickOutsideHandler(event) {
        // Avoid closing component if user clicked on any of those elements
        const excludeElements = [
          'change-store-button',
          'set-store',
          'store-details-closed',
          'edit-location-link',
          'store-details-closed',
          'site-header-action-local'
        ];
  
        if(!this.open || excludeElements.includes(event.target.getAttribute('data-ui'))) return;
  
        if(!storesDropdown.contains(event.target)) {
          eventBus.$emit('closed');
        }
      }
    },
    mounted() {
      eventBus.$on('closed', this.handleClose);
  
      myStoreToggleButton.setAttribute('aria-expanded', 'false');
      myStoreToggleButton.setAttribute('aria-controls', 'my-store-bar');
      
      myStoreToggleButton.addEventListener('click', this.toggleButtonHandler);
      window.addEventListener('click', this.clickOutsideHandler, true);
    },
    beforeDestroy() {
      eventBus.$off('closed', this.handleClose);
      
      myStoreToggleButton.removeEventListener('click', this.toggleButtonHandler);
      window.removeEventListener('click', this.clickOutsideHandler, true);
    },
  });
}


if(myStoreToggleButton && navbarWrapper) {
  ['focus', 'mouseenter'].forEach( eventName => 
    myStoreToggleButton.addEventListener(eventName, function handler(e) {

      if(!isMyStoreMounted) {
        mountMyStore();
      }

      // Remove event listener right away
      e.currentTarget.removeEventListener(eventName, handler);
    })
  );
}
